/** Monthly credit-equivalent safeguards for the yearly Unlimited plan. */
export const UNLIMITED_FAIR_USE = {
  monthlyCredits: 82,
} as const;
